/**
 * Single source of truth for the latest released version of each portal type.
 *
 * Update this file whenever a new version is shipped.
 * The header version display and the changelog navigation cards both read from here.
 *
 * Changelog components (ApiPartnerChangelog.vue, etc.) still contain the full entry
 * cards for every version — this file only tracks the *latest* version per type.
 */

export interface PortalVersionInfo {
  /** Semver string, prefixed with "v" — e.g. "v2.14.0" */
  version: string;
  /** Short description shown in changelog navigation cards */
  label: string;
  /** ISO date string of the release — e.g. "2026-04-21" */
  date: string;
}

export const PORTAL_VERSIONS: Record<string, PortalVersionInfo> = {
  API_PARTNER: {
    version: 'v2.17.0',
    label: 'New POI & Shop troubleshooting pages',
    date: '2026-07-28',
  },
  FLEET_PARTNER: {
    version: 'v1.3.0',
    label: 'New Account Security: Two-Factor Authentication (2FA)',
    date: '2026-04-21',
  },
  ENERGY_NETWORK_PARTNER: {
    version: 'v1.3.0',
    label: 'New Account Security: Two-Factor Authentication (2FA)',
    date: '2026-04-21',
  },
  RYD_INTERNAL: {
    version: 'v2.5.0',
    label: 'New POI & Shop troubleshooting pages',
    date: '2026-07-28',
  },
  INDIVIDUAL_PARTNER: {
    version: 'v1.4.0',
    label: 'New Account Security: Two-Factor Authentication (2FA)',
    date: '2026-04-21',
  },
};
